module.exports = __webpack_public_path__ + "media/bootstrap-icons/emoji-smile-df501afd.svg";